import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { t } = useTranslation();

  const faqs = [
    { questionKey: 'q1', answerKey: 'a1' },
    { questionKey: 'q2', answerKey: 'a2' },
    { questionKey: 'q3', answerKey: 'a3' },
    { questionKey: 'q4', answerKey: 'a4' },
    { questionKey: 'q5', answerKey: 'a5' },
    { questionKey: 'q6', answerKey: 'a6' },
    { questionKey: 'q7', answerKey: 'a7' },
    { questionKey: 'q8', answerKey: 'a8' },
  ];

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            {t('title')}
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((item, index) => (
            <div key={index} className="bg-slate-50 rounded-2xl overflow-hidden border border-slate-100">
              <button
                className="w-full px-8 py-6 text-left flex justify-between items-center hover:bg-slate-100 transition-colors cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h3 className="text-lg font-bold text-slate-800 pr-4">{t(item.questionKey)}</h3>
                <i className={`ri-arrow-down-s-line text-teal-600 text-xl transition-transform ${openIndex === index ? 'rotate-180' : ''}`}></i>
              </button>
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <p className="text-slate-700 leading-relaxed">{t(item.answerKey)}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-teal-50 to-cyan-50 rounded-2xl p-8 text-center">
          <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-question-answer-line text-white text-2xl"></i>
          </div>
          <h3 className="text-2xl font-bold text-slate-800 mb-4">{t('ctaTitle')}</h3>
          <p className="text-slate-600 mb-6 leading-relaxed">{t('ctaDesc')}</p>
          <a
            href="#contact"
            className="bg-teal-500 text-white px-8 py-3 rounded-full font-medium hover:bg-teal-600 transition-colors inline-flex items-center gap-2 whitespace-nowrap"
          >
            {t('ctaButton')}
            <i className="ri-chat-3-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
